export default __webpack_public_path__ + "static/map-1c01611e4a5a7c9108fe0a0179b925da.jpg";